module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-four-new-smc/key-1-2020.svg?v=cc567cba";